import { getTariffsGroup } from '@fttb/common/store';
import { createAction } from '@reduxjs/toolkit';
import { TARIFF_TYPES } from '@fttb/common/constants';
import { getTariffTabsList, getTariffsTitle } from "./selectors";
import { sendTariffsSectionClickAnalytics, sendTariffsTabsChangeTextAnalytics } from "../../../blocks/analytics";
import { getAnalyticEventType } from "../selectors";
import { selectCommonAnalyticsData } from "../../analytics/selectors";
import { getIsOpenPopupFlag } from "../../../components/OrderTariffFormPopup/OrderTariffFormOldPopup/store/selectors/orderTariffCommon";
import { setOrderTariffType } from "../../../components/OrderTariffFormPopup/OrderTariffFormOldPopup/store/reducers/slice";
import { setPopupVisibility } from "../../../components/OrderTariffFormPopup/OrderTariffFormOldPopup/store/actions/common";
import { selectUniConstructorRedirectFlag } from "../../../components/OrderTariffFormPopup/OrderTariffFormOldPopup/store/selectors/modal";
import { openBackCall } from "../../actionBarWithBackCall/actions";
import { getIsActionBarOpen } from "../../selectors";
import { FTTB_PAGE_PREFIX } from "../../constants";
import { showTariffLink } from "./tariffButtonSelectors";
import { getIsHighSpeedTariff, getIsUniConstructorTariffFlag, getTariffAlias, getTariffInacId, getTariffTitle, getTariffTypeWithPresetUp, getTariffUrl, selectIsFttbTariffType } from "./tariffSelectors";
export var setTariffsGroup = createAction("".concat(FTTB_PAGE_PREFIX, "::setTariffsGroup"));
export var setColoredTariffsData = createAction('setColoredTariffData');
export var resetColoredTariffsData = createAction('resetColoredTariffData');
export var setTariffsGroupAnalytics = function setTariffsGroupAnalytics(tabId) {
  return function (dispatch, getState) {
    var _tabs$find;
    var state = getState();
    var tabs = getTariffTabsList(state);
    var tabName = (_tabs$find = tabs.find(function (_ref) {
      var id = _ref.id;
      return id === tabId;
    })) === null || _tabs$find === void 0 ? void 0 : _tabs$find.title;
    var pageType = getAnalyticEventType(state);
    var commonAnalyticsData = selectCommonAnalyticsData(state);
    var blockTitle = getTariffsTitle(state);
    sendTariffsTabsChangeTextAnalytics({
      pageType: pageType,
      commonAnalyticsData: commonAnalyticsData,
      tabName: tabName,
      blockTitle: blockTitle
    });
    dispatch(setTariffsGroup(tabId));
  };
};
export var onTariffButtonClickWithAnalytics = function onTariffButtonClickWithAnalytics(e, isPopular) {
  return function (dispatch, getState) {
    var state = getState();
    var type = getTariffTypeWithPresetUp(state);
    var isLink = showTariffLink(state);
    var alias = getTariffAlias(state);
    var tariffTitle = getTariffTitle(state);
    var group = getTariffsGroup(state);
    var inacId = getTariffInacId(state);
    var pageType = getAnalyticEventType(state);
    var tariffUrl = getTariffUrl(state);
    var commonAnalyticsData = selectCommonAnalyticsData(state);
    var isUniConstructorTariffFlag = getIsUniConstructorTariffFlag(state);
    var isConstructorRedirectFlag = selectUniConstructorRedirectFlag(state);
    var blockTitle = getTariffsTitle(state);
    var isHighSpeedTariff = getIsHighSpeedTariff(state);
    /** флаг наличия редиректа в деталку тарифа
     * если isConstructorRedirectFlag - true и isUniConstructorTariffFlag - true = редирект
     * если isConstructorCallbackFlag - false и isUniConstructorTariffFlag - true - форма обратного звонка
     * если isConstructorCallbackFlag - true или false и isUniConstructorTariffFlag - false - дефолтный сценарий */
    var isRedirectTo = isConstructorRedirectFlag && isUniConstructorTariffFlag;
    sendTariffsSectionClickAnalytics({
      group: group,
      pageType: pageType,
      tariffTitle: tariffTitle,
      blockTitle: blockTitle,
      commonAnalyticsData: commonAnalyticsData
    });
    if (isLink && !isUniConstructorTariffFlag || isRedirectTo) {
      return;
    }
    e.preventDefault();
    if (isUniConstructorTariffFlag) {
      dispatch(openBackCall(true)); // отправляем флаг =true если клик по тарифной карточке
    } else {
      dispatch(setPopupVisibility());
    }
    dispatch(setOrderTariffType({
      inacId: inacId,
      isPopular: isPopular,
      alias: alias,
      group: group,
      tariffType: type,
      tariffUrl: tariffUrl,
      isHighSpeedTariff: isHighSpeedTariff,
      /** при выключенном тогле перехода в деталку и ниличии признака тарифа ун. конструктора - показ формы заказа обратного звонка */
      // @ts-expect-error fix later
      isTariffCallbackFlag: !isConstructorRedirectFlag && isUniConstructorTariffFlag
    }));
  };
};
export var onTariffCardClick = function onTariffCardClick(e, isPopular) {
  return function (dispatch, getState) {
    var state = getState();
    var isOpen = getIsOpenPopupFlag(state);
    var isActionBarOpen = getIsActionBarOpen(state);
    var type = getTariffTypeWithPresetUp(state);
    var isFttbTariffType = selectIsFttbTariffType(state);
    var isUniConstructorTariffFlag = getIsUniConstructorTariffFlag(state);
    if (isOpen || isActionBarOpen) return;
    if (type === TARIFF_TYPES.partnerFmc || isFttbTariffType || isUniConstructorTariffFlag) {
      dispatch(onTariffButtonClickWithAnalytics(e, isPopular));
    }
  };
};